import { render, staticRenderFns } from "./ReceiverOrgItemPage.vue?vue&type=template&id=e2d5ab76&"
import script from "./ReceiverOrgItemPage.vue?vue&type=script&lang=js&"
export * from "./ReceiverOrgItemPage.vue?vue&type=script&lang=js&"
import style0 from "./ReceiverOrgItemPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports